<template>
  <svg
    class="filter__icon"
    width="13.689"
    height="13.68"
    viewBox="0 0 13.689 13.68"
  >
    <g id="noun_filter_1721071" transform="translate(-9.88 -100.623)">
      <g
        id="Group_5908"
        data-name="Group 5908"
        transform="translate(10.08 100.822)"
      >
        <g id="Group_5907" data-name="Group 5907" transform="translate(0 0)">
          <path
            id="Path_7082"
            data-name="Path 7082"
            d="M112.9,101.621c0,.086.024-.056,0,.023,0,.016-.039.087,0,.023-.01.019-.024.039-.034.058.024-.055.065-.082.044-.056l-.029.035-.134.169q-.261.332-.523.665l-1.661,2.106q-.85,1.077-1.7,2.154c-.266.339-.534.676-.8,1.015a.464.464,0,0,0-.1.341v4.086h0v.024c0,.037,0,.032,0-.013a.214.214,0,0,1-.019.068c.032-.032.019-.037,0-.013l-.011.019q-.029.044.01-.01c-.01.011-.021.023-.032.034s-.023.021.013-.006c-.027.036-.092.05-.131.073l-.145.084-1.159.67-.41.237-.034.019,0,0-.018.008c.053-.021.06-.024.018-.01a.32.32,0,0,1-.042.011c-.04.015.065.006-.016,0h-.023c-.036,0-.029,0,.021,0,0,0-.058-.015-.063-.016-.066-.016.056.037,0,0a.408.408,0,0,0-.035-.021c-.06-.034.045.05,0,0s-.013,0,0,0-.032-.056-.039-.061c-.026-.026.019.071,0,.01a.606.606,0,0,1-.016-.063c0,.015,0,.029,0,.042a.392.392,0,0,1,0-.044h0v-5.163a.437.437,0,0,0-.1-.315c-.023-.029-.047-.058-.069-.089-.14-.179-.281-.357-.423-.536l-1.559-1.979q-.879-1.114-1.756-2.229-.506-.641-1.01-1.283c-.01-.011-.018-.023-.027-.035s.016,0,.045.056c-.01-.019-.024-.039-.034-.058.035.065,0-.006,0-.023q-.01-.056,0,0a.259.259,0,0,1,0-.05c0-.066-.019.042,0,.01a.481.481,0,0,0,.015-.052c.016-.068-.037.056,0,0,0,0,.029-.055.034-.053s-.044.06,0,0c.034-.039-.013.024-.018.01s.048-.031.053-.034c.031-.016.024-.013-.019.006l.04-.013.021,0c.027,0,.027-.006,0,0l-.021,0a.392.392,0,0,1,.044,0h.01c.108,0,.216,0,.324,0H112.77c.073,0-.066-.023,0,0a.379.379,0,0,0,.04.011c.068.016-.056-.037,0,0,0,0,.055.029.053.034s-.06-.044,0,0-.019-.044,0-.01a.4.4,0,0,0,.027.044c.039.056-.016-.068,0,0a.606.606,0,0,1,.016.063c0-.015,0-.029,0-.042,0,.021,0,.036,0,.05a.323.323,0,1,0,.646,0,.807.807,0,0,0-.8-.8H102.028c-.326,0-.652-.006-.976,0a.81.81,0,0,0-.8.775.819.819,0,0,0,.2.549l.345.437q.758.963,1.517,1.925l1.8,2.288q.554.7,1.107,1.406l.053.068c-.032-.076-.063-.152-.1-.228v5.164a.886.886,0,0,0,.226.639.8.8,0,0,0,.826.2,1.168,1.168,0,0,0,.2-.1l1.344-.778c.123-.071.244-.147.368-.213a.808.808,0,0,0,.447-.6,1.144,1.144,0,0,0,.011-.165v-4.149c-.032.076-.063.152-.1.228.168-.215.337-.428.505-.642l1.2-1.517,1.438-1.824,1.2-1.525c.169-.215.341-.429.508-.646a.829.829,0,0,0,.179-.5.325.325,0,0,0-.323-.323A.328.328,0,0,0,112.9,101.621Z"
            transform="translate(-100.254 -100.822)"
            fill="#778d9d"
            stroke="#778d9d"
            stroke-width="0.4"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "FilterIcon"
};
</script>
<style lang="less" scoped>
.filter__icon {
  vertical-align: middle;
}
</style>
